import { t } from "i18next";
import { useEffect, useState } from "react";
import { MULTI, Selector } from "./Selector";

export const GoalsSingleSelect = ({
  id = "goal-selector",
  selectHandler,
  goalsList,
  selectedGoal,
  size,
  clear,
  isRequired,
  interaction,
}) => {
  const [goals, setGoals] = useState([]);

  useEffect(() => {
    if (goalsList) {
      let goalOptions = [];
      goalsList.forEach((goal) => {
        goalOptions.push({
          id: goal.id,
          name: goal.description,
          label: goal.description,
        });
      });
      setGoals(goalOptions);
    }
  }, [goalsList]);

  return (
    <Selector
      id={id}
      label={t("cyclesAndGoals.cycleGoal.goal") + (isRequired ? "*" : "")}
      assistiveText={t("cyclesAndGoals.cycleGoal.assistiveText")}
      selectHandler={selectHandler}
      options={goals ? goals : []}
      selectedItemId={selectedGoal}
      size={size}
      clear={clear}
      interaction={interaction}
    />
  );
};

export const GoalsMultiSelect = ({
  selectHandler,
  goalsList,
  selectedGoals,
  size,
}) => {
  const [goals, setGoals] = useState([]);

  useEffect(() => {
    if (goalsList) {
      let goalOptions = [];
      goalsList.forEach((goal) => {
        goalOptions.push({
          id: goal.id,
          name: goal.description,
          label: goal.description,
        });
      });
      setGoals(goalOptions);
    }
  }, [goalsList]);

  return (
    <Selector
      type={MULTI}
      id="goals-selector"
      label={t("results.goalsFilter")}
      assistiveText={t("results.goalsFilter")}
      selectHandler={selectHandler}
      selectedOptions={selectedGoals}
      options={goals ? goals : []}
      size={size}
    />
  );
};
